import {
  buildDeserializer,
  buildSerializer,
  SerializeMap,
} from "lib/serializerUtils";

const allocationsMap: SerializeMap<VendorSplitAllocation> = {
  businessId: "business_id",
  amount: "amount",
  shouldChargeGSTOverride: "should_charge_gst_override",
};

export const vendorSplitSerializerMap: SerializeMap<VendorSplit> = {
  id: "id",
  consignmentId: "consignment_id",
  livestockSaleId: "livestock_sale_id",
  deploymentId: "deployment_id",
  includeFees: "include_fees",
  isActive: "is_active",
  isDefault: "is_default",
  primaryBusinessId: "primary_business_id",
  saleLotId: "sale_lot_id",
  type: "type",
  splits: allocationsMap,
};

export const serializeVendorSplit = buildSerializer<VendorSplit>(
  vendorSplitSerializerMap,
  "vendorSplit",
  { splits: "splits" },
);

export const deserializeVendorSplit = buildDeserializer<VendorSplit>(
  vendorSplitSerializerMap,
  "vendorSplit",
  { splits: "splits" },
);
